import { provideIcons } from '@ng-icons/core';
import {
  phosphorArrowClockwise,
  phosphorArrowCounterClockwise,
  phosphorArrowDown,
  phosphorArrowLeft,
  phosphorArrowRight,
  phosphorArrowsClockwise,
  phosphorArrowsCounterClockwise,
  phosphorArrowsLeftRight,
  phosphorArrowSquareOut,
  phosphorArrowUp,
  phosphorArticle,
  phosphorBank,
  phosphorBell,
  phosphorBellRinging,
  phosphorBellSimple,
  phosphorBellZ,
  phosphorBookmark,
  phosphorBriefcase,
  phosphorBuildings,
  phosphorCalendar,
  phosphorCalendarBlank,
  phosphorCalendarCheck,
  phosphorCalendarDots,
  phosphorCalendarSlash,
  phosphorCaretDown,
  phosphorCaretLeft,
  phosphorCaretRight,
  phosphorCaretUp,
  phosphorCaretUpDown,
  phosphorCertificate,
  phosphorChartLine,
  phosphorChatCircle,
  phosphorChats,
  phosphorChatText,
  phosphorCheck,
  phosphorCheckCircle,
  phosphorCheckFat,
  phosphorChecks,
  phosphorCheckSquareOffset,
  phosphorCircleHalfTilt,
  phosphorCircleNotch,
  phosphorCity,
  phosphorClipboardText,
  phosphorClock,
  phosphorClockAfternoon,
  phosphorClockCountdown,
  phosphorCloudSlash,
  phosphorCoffee,
  phosphorCopy,
  phosphorCreditCard,
  phosphorCurrencyDollar,
  phosphorCurrencyDollarSimple,
  phosphorCursor,
  phosphorCursorClick,
  phosphorDotsThree,
  phosphorDotsThreeCircle,
  phosphorDotsThreeVertical,
  phosphorDownload,
  phosphorEmpty,
  phosphorEnvelope,
  phosphorEnvelopeSimple,
  phosphorExport,
  phosphorEye,
  phosphorEyeClosed,
  phosphorEyeSlash,
  phosphorFacebookLogo,
  phosphorFile,
  phosphorFileArchive,
  phosphorFileAudio,
  phosphorFileC,
  phosphorFileCpp,
  phosphorFileCSharp,
  phosphorFileCss,
  phosphorFileCsv,
  phosphorFileDashed,
  phosphorFileDoc,
  phosphorFileHtml,
  phosphorFileImage,
  phosphorFileJpg,
  phosphorFileJs,
  phosphorFileJsx,
  phosphorFileMd,
  phosphorFilePdf,
  phosphorFilePng,
  phosphorFilePpt,
  phosphorFilePy,
  phosphorFileSql,
  phosphorFileSvg,
  phosphorFileText,
  phosphorFileTs,
  phosphorFileTsx,
  phosphorFileTxt,
  phosphorFileVideo,
  phosphorFileVue,
  phosphorFileXls,
  phosphorFileZip,
  phosphorFirstAid,
  phosphorFloppyDisk,
  phosphorFolder,
  phosphorFunnel,
  phosphorFunnelSimple,
  phosphorGear,
  phosphorGithubLogo,
  phosphorHandshake,
  phosphorHandTap,
  // Common icons - add more as needed
  phosphorHeart,
  phosphorHourglass,
  phosphorHouse,
  phosphorIdentificationCard,
  phosphorImage,
  phosphorInfo,
  phosphorInvoice,
  phosphorLayout,
  phosphorLightning,
  phosphorLink,
  phosphorLinkedinLogo,
  phosphorList,
  phosphorListDashes,
  phosphorLock,
  phosphorLockOpen,
  phosphorMagnifyingGlass,
  phosphorMapPin,
  phosphorMedal,
  phosphorMinus,
  phosphorMoneyWavy,
  phosphorMonitor,
  phosphorMoon,
  phosphorMouseSimple,
  phosphorNavigationArrow,
  phosphorNote,
  phosphorNotePencil,
  phosphorPalette,
  phosphorPaperclip,
  phosphorPaperPlaneRight,
  phosphorPaperPlaneTilt,
  phosphorPencil,
  phosphorPencilLine,
  phosphorPencilSimple,
  phosphorPercent,
  phosphorPhone,
  phosphorPlayCircle,
  phosphorPlug,
  phosphorPlus,
  phosphorPlusCircle,
  phosphorProhibit,
  phosphorQuestion,
  phosphorReceipt,
  phosphorSealCheck,
  phosphorShare,
  phosphorShieldCheck,
  phosphorShieldWarning,
  phosphorSignOut,
  phosphorSlidersHorizontal,
  phosphorSmiley,
  phosphorSmileySad,
  phosphorSpinner,
  phosphorSquaresFour,
  phosphorStack,
  phosphorStar,
  phosphorSyringe,
  phosphorTarget,
  phosphorTextbox,
  phosphorThumbsUp,
  phosphorTrash,
  phosphorTray,
  phosphorTrendDown,
  phosphorTrendUp,
  phosphorUpload,
  phosphorUploadSimple,
  phosphorUser,
  phosphorUserCheck,
  phosphorUserCircle,
  phosphorUserPlus,
  phosphorUsers,
  phosphorUsersThree,
  phosphorWarning,
  phosphorWarningCircle,
  phosphorWifiSlash,
  phosphorX,
  phosphorXCircle
} from '@ng-icons/phosphor-icons/regular';

import {
  phosphorArrowCircleRightBold,
  phosphorBellRingingBold,
  phosphorBellSlashBold,
  phosphorBookOpenBold,
  phosphorBuildingsBold,
  phosphorCalendarCheckBold,
  phosphorCertificateBold,
  phosphorCheckBold,
  phosphorCheckCircleBold,
  phosphorChecksBold,
  phosphorClipboardTextBold,
  phosphorDoorBold,
  phosphorDotsThreeVerticalBold,
  phosphorExportBold,
  phosphorFileBold,
  phosphorHandCoinsBold,
  phosphorHospitalBold,
  phosphorHourglassBold,
  phosphorInvoiceBold,
  phosphorLightningBold,
  phosphorListBulletsBold,
  phosphorPasswordBold,
  phosphorPlayCircleBold,
  phosphorPlusBold,
  phosphorProhibitBold,
  phosphorReceiptXBold,
  phosphorSealCheckBold,
  phosphorWarningBold,
  phosphorWarningCircleBold,
  phosphorXBold,
  phosphorXCircleBold,
  phosphorReadCvLogoBold,
  phosphorCityBold
} from '@ng-icons/phosphor-icons/bold';
import {
  phosphorCheckCircleFill,
  phosphorEnvelopeFill,
  phosphorHeartFill,
  phosphorIdentificationCardFill,
  phosphorLightningFill,
  phosphorMoonFill,
  phosphorStarFill
} from '@ng-icons/phosphor-icons/fill';

/**
 * Provider for Phosphor Icons used in UMSS Design System
 *
 * ```typescript
 * import { provideUmssIcons } from '@umss/shared/ui';
 *
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideUmssIcons(),
 *     // ... other providers
 *   ]
 * };
 * ```
 */
export function provideUmssIcons() {
  return provideIcons({
    // Hearts & Favorites
    phosphorHeart,
    phosphorHeartFill,
    phosphorStar,
    phosphorIdentificationCardFill,
    phosphorMoonFill,

    // Bold variants
    phosphorDotsThreeVerticalBold,
    phosphorExportBold,
    phosphorDoorBold,
    phosphorBookOpenBold,
    phosphorHandCoinsBold,
    phosphorHospitalBold,
    phosphorArrowCircleRightBold,
    phosphorBellRingingBold,
    phosphorBellSlashBold,
    phosphorCalendarCheckBold,
    phosphorCertificateBold,
    phosphorFileBold,
    phosphorClipboardTextBold,
    phosphorInvoiceBold,
    phosphorCheckBold,
    phosphorSealCheckBold,
    phosphorWarningCircleBold,
    phosphorPasswordBold,
    phosphorLightningBold,
    phosphorHourglassBold,
    phosphorCheckCircleBold,
    phosphorPlayCircleBold,
    phosphorChecksBold,
    phosphorListBulletsBold,
    phosphorXCircleBold,
    phosphorXBold,
    phosphorBuildingsBold,
    phosphorReadCvLogoBold,
    phosphorProhibitBold,
    phosphorReceiptXBold,
    phosphorPlusBold,
    phosphorWarningBold,

    // Status & Feedback
    phosphorCheck,
    phosphorChecks,
    phosphorCheckFat,
    phosphorCheckCircle,
    phosphorCheckCircleFill,
    phosphorCheckSquareOffset,
    phosphorShieldCheck,
    phosphorShieldWarning,
    phosphorX,
    phosphorXCircle,
    phosphorInfo,
    phosphorWarning,
    phosphorWarningCircle,
    phosphorQuestion,
    phosphorPencilLine,
    phosphorCircleHalfTilt,

    // Actions
    phosphorPlus,
    phosphorMinus,
    phosphorTrash,
    phosphorPencil,
    phosphorPencilSimple,
    phosphorCopy,
    phosphorShare,
    phosphorUpload,
    phosphorUploadSimple,
    phosphorDownload,
    phosphorExport,
    phosphorFloppyDisk,

    // Navigation
    phosphorCaretDown,
    phosphorCaretUp,
    phosphorCaretUpDown,
    phosphorCaretLeft,
    phosphorCaretRight,
    phosphorArrowLeft,
    phosphorArrowRight,
    phosphorArrowUp,
    phosphorArrowDown,
    phosphorArrowClockwise,
    phosphorHouse,
    phosphorList,
    phosphorSlidersHorizontal,
    phosphorNavigationArrow,

    // UI Elements
    phosphorMagnifyingGlass,
    phosphorEye,
    phosphorEyeClosed,
    phosphorEyeSlash,
    phosphorDotsThree,
    phosphorDotsThreeCircle,
    phosphorDotsThreeVertical,
    phosphorFunnel,
    phosphorFunnelSimple,
    phosphorGear,
    phosphorBell,
    phosphorCircleNotch,
    phosphorSpinner,
    phosphorBookmark,
    phosphorThumbsUp,
    phosphorCurrencyDollar,
    phosphorPercent,
    phosphorCreditCard,
    phosphorUsers,
    phosphorUsersThree,

    phosphorUserPlus,
    phosphorBuildings,
    phosphorBriefcase,
    phosphorGithubLogo,
    phosphorPlug,
    phosphorLightning,
    phosphorLightningFill,
    phosphorChatCircle,
    phosphorLayout,
    phosphorTextbox,
    phosphorStack,
    phosphorArrowsClockwise,
    phosphorArrowsLeftRight,
    phosphorCursor,
    phosphorCursorClick,
    phosphorHandTap,
    phosphorMouseSimple,
    phosphorPalette,
    phosphorCurrencyDollarSimple,
    phosphorUserCheck,
    phosphorBellSimple,
    phosphorSyringe,
    phosphorIdentificationCard,
    phosphorSealCheck,
    phosphorBellRinging,
    phosphorMoneyWavy,
    phosphorTrendUp,
    phosphorBank,
    phosphorInvoice,
    phosphorChats,
    phosphorCity,
    phosphorCertificate,
    phosphorFirstAid,
    phosphorMedal,

    // User & Communication
    phosphorUser,
    phosphorUserCircle,
    phosphorEnvelope,
    phosphorEnvelopeFill,
    phosphorPhone,
    phosphorMapPin,
    phosphorHandshake,
    phosphorTarget,
    phosphorEnvelopeSimple,

    // Files & Data
    phosphorFolder,
    phosphorFile,
    phosphorFileArchive,
    phosphorFileAudio,
    phosphorFileC,
    phosphorFileCpp,
    phosphorFileCSharp,
    phosphorFileCss,
    phosphorFileCsv,
    phosphorFileDashed,
    phosphorFileDoc,
    phosphorFileHtml,
    phosphorFileImage,
    phosphorFileJs,
    phosphorFileJpg,
    phosphorFileJsx,
    phosphorFileMd,
    phosphorFilePdf,
    phosphorFilePng,
    phosphorFilePpt,
    phosphorFilePy,
    phosphorFileSql,
    phosphorFileSvg,
    phosphorFileText,
    phosphorFileTs,
    phosphorFileTsx,
    phosphorFileTxt,
    phosphorFileVideo,
    phosphorFileVue,
    phosphorFileXls,
    phosphorFileZip,
    phosphorImage,
    phosphorLink,
    phosphorChartLine,
    phosphorTray,
    phosphorPaperPlaneTilt,
    phosphorPaperPlaneRight,
    phosphorNote,
    phosphorNotePencil,
    phosphorSquaresFour,
    phosphorPaperclip,
    phosphorCityBold,

    // Time & Calendar
    phosphorCalendar,
    phosphorCalendarBlank,
    phosphorCalendarCheck,
    phosphorCalendarDots,
    phosphorCalendarSlash,
    phosphorClock,
    phosphorClockCountdown,
    phosphorArrowsCounterClockwise,

    // Devices
    phosphorMonitor,
    phosphorMoon,

    // Documents & Forms
    phosphorReceipt,
    phosphorClipboardText,

    // Security
    phosphorLock,
    phosphorLockOpen,
    phosphorSignOut,

    // Social Icons

    phosphorLinkedinLogo,
    phosphorFacebookLogo,
    phosphorEmpty,

    // Errors

    phosphorProhibit,
    phosphorWifiSlash,
    phosphorCloudSlash,
    phosphorTrendDown,
    phosphorArrowSquareOut,
    phosphorArrowCounterClockwise,
    phosphorSmileySad,
    phosphorSmiley,
    phosphorPlayCircle,
    phosphorHourglass,
    phosphorBellZ,
    phosphorClockAfternoon,
    phosphorCoffee,
    phosphorListDashes,
    phosphorArticle,
    phosphorPlusCircle,
    phosphorChatText,

    // Ratings

    phosphorStarFill
  });
}

/**
 * List of all registered icon names for reference
 * Use these names with the umss-icon component
 */
export const UMSS_ICON_NAMES = [
  'phosphorHeart',
  'phosphorHeartFill',
  'phosphorIdentificationCardFill',
  'phosphorMoonFill',
  'phosphorStar',
  'phosphorDotsThreeVerticalBold',
  'phosphorExportBold',
  'phosphorDoorBold',
  'phosphorBookOpenBold',
  'phosphorHandCoinsBold',
  'phosphorHospitalBold',
  'phosphorArrowCircleRightBold',
  'phosphorBellRingingBold',
  'phosphorBellSlashBold',
  'phosphorCalendarCheckBold',
  'phosphorCertificateBold',
  'phosphorFileBold',
  'phosphorClipboardTextBold',
  'phosphorInvoiceBold',
  'phosphorSealCheckBold',
  'phosphorWarningCircleBold',
  'phosphorPasswordBold',
  'phosphorLightningBold',
  'phosphorHourglassBold',
  'phosphorCheckCircleBold',
  'phosphorPlayCircleBold',
  'phosphorChecksBold',
  'phosphorListBulletsBold',
  'phosphorXCircleBold',
  'phosphorXBold',
  'phosphorBuildingsBold',
  'phosphorCityBold',
  'phosphorReadCvLogoBold',
  'phosphorProhibitBold',
  'phosphorWarningBold',
  'phosphorCheck',
  'phosphorChecks',
  'phosphorCheckFat',
  'phosphorCheckCircle',
  'phosphorCheckCircleFill',
  'phosphorCheckSquareOffset',
  'phosphorShieldCheck',
  'phosphorX',
  'phosphorXCircle',
  'phosphorInfo',
  'phosphorWarning',
  'phosphorWarningCircle',
  'phosphorQuestion',
  'phosphorPlus',
  'phosphorMinus',
  'phosphorTrash',
  'phosphorPencil',
  'phosphorPencilSimple',
  'phosphorCopy',
  'phosphorShare',
  'phosphorUpload',
  'phosphorUploadSimple',
  'phosphorDownload',
  'phosphorExport',
  'phosphorCaretDown',
  'phosphorCaretUp',
  'phosphorCaretUpDown',
  'phosphorCaretLeft',
  'phosphorCaretRight',
  'phosphorArrowLeft',
  'phosphorArrowRight',
  'phosphorArrowUp',
  'phosphorArrowDown',
  'phosphorArrowClockwise',
  'phosphorHouse',
  'phosphorList',
  'phosphorSquaresFour',
  'phosphorMagnifyingGlass',
  'phosphorEye',
  'phosphorEyeClosed',
  'phosphorEyeSlash',
  'phosphorDotsThree',
  'phosphorDotsThreeVertical',
  'phosphorFunnel',
  'phosphorFunnelSimple',
  'phosphorGear',
  'phosphorBell',
  'phosphorCircleNotch',
  'phosphorSpinner',
  'phosphorBookmark',
  'phosphorThumbsUp',
  'phosphorCurrencyDollar',
  'phosphorPercent',
  'phosphorCreditCard',
  'phosphorUsers',
  'phosphorUserPlus',
  'phosphorBuildings',
  'phosphorBriefcase',
  'phosphorGithubLogo',
  'phosphorPlug',
  'phosphorLightning',
  'phosphorLightningFill',
  'phosphorChatCircle',
  'phosphorLayout',
  'phosphorTextbox',
  'phosphorStack',
  'phosphorArrowsClockwise',
  'phosphorCursor',
  'phosphorCursorClick',
  'phosphorHandTap',
  'phosphorMouseSimple',
  'phosphorPalette',
  'phosphorUser',
  'phosphorUserCircle',
  'phosphorEnvelope',
  'phosphorEnvelopeFill',
  'phosphorPhone',
  'phosphorMapPin',
  'phosphorFolder',
  'phosphorFile',
  'phosphorFileText',
  'phosphorFileDashed',
  'phosphorImage',
  'phosphorLink',
  'phosphorChartLine',
  'phosphorTray',
  'phosphorPaperPlaneTilt',
  'phosphorPaperPlaneRight',
  'phosphorNote',
  'phosphorNotePencil',
  'phosphorPaperclip',
  'phosphorCalendar',
  'phosphorCalendarBlank',
  'phosphorCalendarCheck',
  'phosphorClock',
  'phosphorReceipt',
  'phosphorClipboardText',
  'phosphorLock',
  'phosphorLockOpen',
  'phosphorSignOut',
  'phosphorFacebookLogo',
  'phosphorLinkedinLogo',
  'phosphorHandshake',
  'phosphorTarget',
  'phosphorClockCountdown',
  'phosphorArrowsCounterClockwise',
  'phosphorCurrencyDollarSimple',
  'phosphorBellSimple',
  'phosphorUserCheck',
  'phosphorSyringe',
  'phosphorIdentificationCard',
  'phosphorProhibit',
  'phosphorWifiSlash',
  'phosphorTrendDown',
  'phosphorSlidersHorizontal',
  'phosphorCloudSlash',
  'phosphorMonitor',
  'phosphorBellRinging',
  'phosphorMoneyWavy',
  'phosphorTrendUp',
  'phosphorBank',
  'phosphorArrowSquareOut',
  'phosphorShieldWarning',
  'phosphorCircleHalfTilt',
  'phosphorChats',
  'phosphorInvoice',
  'phosphorEnvelopeSimple',
  'phosphorNavigationArrow',
  'phosphorArrowCounterClockwise',
  'phosphorSmileySad',
  'phosphorPlayCircle',
  'phosphorHourglass',
  'phosphorEmpty',
  'phosphorCalendarDots',
  'phosphorCalendarSlash',
  'phosphorSmiley',
  'phosphorBellZ',
  'phosphorClockAfternoon',
  'phosphorCoffee',
  'phosphorReceiptXBold',
  'phosphorArticle',
  'phosphorCity',
  'phosphorFloppyDisk',
  'phosphorPlusCircle',
  'phosphorStarFill',
  'phosphorChatText'
] as const;

export type UmssIconName = (typeof UMSS_ICON_NAMES)[number];
